import Cookies from 'js-cookie';
import {io, Socket} from 'socket.io-client';
import {SOCKET_URL} from '../utils/constants';

type SocketAuth = {
  access_token: string;
  platform?: string;
  language?: string;
  tracking_id?: string;
  user_agent?: string;
  name?: string;
  avatar?: string;
};

const initializeSocket = (auth: SocketAuth): Socket => {
  return io(process.env.REACT_APP_SOCKET_URL ?? SOCKET_URL, {
    auth,
    extraHeaders: {},
    transports: ['websocket'],
    // Keep Socket.IO's default continuing retries; the delay stays capped below.
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 5000,
    autoConnect: true,
  });
};

let socket: ReturnType<typeof initializeSocket> | null = null;

export function buildSocketAuth(token: string, displayName: string, displayAvatar: string) {
  return {
    access_token: 'Bearer ' + token,
    platform: Cookies.get('source'),
    language: Cookies.get('NEXT_LOCALE') === 'ku' ? 'ar' : Cookies.get('NEXT_LOCALE'),
    tracking_id: Cookies.get('device_uuid'),
    user_agent: window?.navigator?.userAgent,
    name: displayName,
    avatar: displayAvatar,
  };
}

export function getSocket(auth: SocketAuth) {
  if (!socket) {
    socket = initializeSocket(auth);
  }

  return socket;
}

export function resetSocket() {
  if (!socket) {
    return;
  }

  socket.disconnect();
  socket.removeAllListeners();
  socket = null;
}
